const bookingActionTypes = Object.freeze({
    update: 'BOOKING_UPDATE',
    clear: 'BOOKING_CLEAR'
});

export default bookingActionTypes;
